export type AdminMessageFormValues = {
  email: string;
  subject: string;
  body: string;
};

export type AdminMessageFormErrors = Partial<Record<keyof AdminMessageFormValues, string>>;

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateAdminMessageForm(
  values: AdminMessageFormValues,
  labels: { email: string; subject: string; body: string; invalidEmail: string },
): AdminMessageFormErrors {
  const errors: AdminMessageFormErrors = {};
  const email = values.email.trim();
  const subject = values.subject.trim();
  const body = values.body.trim();
  if (!email) errors.email = labels.email;
  else if (!EMAIL_RE.test(email)) errors.email = labels.invalidEmail;
  if (!subject) errors.subject = labels.subject;
  if (!body) errors.body = labels.body;
  return errors;
}
